(function () {
  "use strict";

  function formatScentOptions() {
    document
      .querySelectorAll(".cart-item__option.cart-item__option--flex dd")
      .forEach(function (element) {
        var text = element.textContent.replace(/\s+/g, " ").trim();

        var match = text.match(
          /^(\d+(?:\.\d+)?)\s*[x×]\s*(.*?)\s*\(SKU:\s*[^)]+\)\s*\(\s*\$([\d,]+(?:\.\d{1,2})?)\s*\)$/
        );

        if (!match) return;

        var quantity = Number(match[1]);
        var optionName = match[2].trim();
        var unitPrice = Number(match[3].replace(/,/g, ""));

        if (!Number.isFinite(quantity) || !Number.isFinite(unitPrice)) {
          return;
        }

        var extendedPrice = quantity * unitPrice;

        var formattedPrice = new Intl.NumberFormat("en-US", {
          style: "currency",
          currency: "USD"
        }).format(extendedPrice);

        element.textContent =
          quantity + " × " + optionName + " (" + formattedPrice + ")";
      });
  }

  function scheduleFormatting() {
    window.requestAnimationFrame(formatScentOptions);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", scheduleFormatting);
  } else {
    scheduleFormatting();
  }

  new MutationObserver(scheduleFormatting).observe(document.body, {
    childList: true,
    subtree: true
  });

  document.addEventListener("cart:updated", scheduleFormatting);
  document.addEventListener("cart:refresh", scheduleFormatting);
})();